<script setup lang="ts">
import SkeletonLoader from '@/shared/components/UI/SkeletonLoader.vue';
</script>
<template>
  <div class="relative flex gap-4 overflow-hidden">
    <SkeletonLoader type="image" class="size-16" />
    <div class="flex grow flex-col gap-1.5">
      <SkeletonLoader type="text-sm" class="w-12" />
      <SkeletonLoader type="text-base" class="w-44" />
      <SkeletonLoader type="text-sm" class="w-24" />
      <SkeletonLoader type="text-base" class="mt-2 w-12" />
    </div>
    <div class="flex flex-col items-end gap-2">
      <SkeletonLoader type="image" class="h-10 w-24" />
      <SkeletonLoader type="text-base" class="w-12 text-base" />
    </div>
  </div>
</template>
